import { useState } from "react";
import { Loader2, Upload, HardDrive } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { DateHourFields, defaultSlot } from "@/components/social/ScheduleDialog";

export const OwnCreativeDialog = ({ title, withSchedule, onClose, onSubmit }) => {
  const [file, setFile] = useState(null);
  const [link, setLink] = useState("");
  const [slot, setSlot] = useState(defaultSlot);
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    const fd = new FormData();
    if (file) fd.append("file", file); else fd.append("drive_link", link);
    if (withSchedule) { fd.append("slot_key", slot.date); fd.append("hour", slot.hour); }
    setBusy(true);
    try { await onSubmit(fd); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && !busy && onClose()}>
      <DialogContent data-testid="own-creative-dialog" className="max-w-md">
        <DialogHeader><DialogTitle>{title}</DialogTitle></DialogHeader>
        <label className="flex cursor-pointer items-center gap-2 rounded-lg border border-dashed border-zinc-400 px-3 py-3 text-sm hover:border-amber-500">
          <Upload className="h-4 w-4" /> <span className="truncate" data-testid="own-creative-file-name">{file ? file.name : "Alege imaginea sau video-ul din telefon / calculator"}</span>
          <input data-testid="own-creative-file-input" type="file" accept="image/*,video/mp4,video/quicktime" className="hidden" onChange={(e) => { setFile(e.target.files?.[0] || null); setLink(""); }} />
        </label>
        <div className="flex items-center gap-2 text-xs text-zinc-500"><HardDrive className="h-3.5 w-3.5" /> sau link de fișier din Google Drive</div>
        <Input data-testid="own-creative-drive-link" value={link} disabled={!!file} onChange={(e) => setLink(e.target.value)} placeholder="https://drive.google.com/file/d/…" />
        {withSchedule && <DateHourFields value={slot} onChange={setSlot} />}
        <p className="text-[11px] text-zinc-500">Imagine 1:1 sau 4:5 (cerința Instagram pentru feed) — AI-ul scrie textul și face Story-ul 9:16 din ea (~$0.15). Video MP4/MOV de 3–60 secunde, ideal 9:16 — se publică ca Reel, iar Story-ul e chiar video-ul; textul e scris din cadrele video-ului. Textul îl poți edita oricând, inclusiv linkul.</p>
        <button data-testid="own-creative-submit" onClick={submit} disabled={busy || (!file && !link.trim())} className="inline-flex items-center justify-center gap-2 rounded-full bg-amber-400 px-4 py-2 text-sm font-semibold text-zinc-950 disabled:opacity-50">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />} {busy ? "Încarc și analizez creativul… (video: până la 1–2 min)" : "Folosește creativul"}
        </button>
      </DialogContent>
    </Dialog>
  );
};
